<template>
    <div class="wapper">
        <el-container style="100%">
            <ProjectHotel @getPTypeId="getPTypeId"></ProjectHotel>
            <el-main style="background:#fff;margin-left:15px;">
                <div class="table-wrap" v-show="listShow">
                    <div class="handle-box3">
                        <el-form :inline="true" ref="form" :model="searchForm" class="demo-form-inline">
                            <div class="uers-left">
                                <el-form-item label="搜索：">
                                    <el-input v-model="searchForm.keyword" placeholder="名称"></el-input>
                                </el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="searchSubmit()">搜索</el-button>
                            </div>
                            <div class="uers-right">
                <span class="btn-r">
                  <el-button type="primary" plain icon="el-icon-plus" @click="addSubmit">新增</el-button>
                    &nbsp;&nbsp;<el-popover
                                        placement="bottom"
                                        title="批量导入"
                                        width="220"
                                        trigger="click"
                                >
                                    <div>
                                        <el-upload
                                                class="upload-demo"
                                                :action="action"
                                                :auto-upload="false"
                                                :on-change="uploadChange"
                                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        >
                                            <el-button size="small" type="primary"
                                            >选择导入模板
                                            </el-button
                                            >
                                        </el-upload>
                                        <el-button
                                                type="success"
                                                @click="download"
                                                plain
                                                icon="el-icon-download"
                                                class="down-template"
                                        >下载模板
                                        </el-button
                                        >
                                    </div>
                                    <p class="import-text">只能选择 .xls .xlsx 文件</p>
                                    <div>
                                        <el-button type="success" @click="importData"
                                        >开始导入
                                        </el-button
                                        >
                                    </div>
                                    <el-button
                                            type="primary"
                                            plain
                                            icon="el-icon-upload2"
                                            slot="reference"
                                    >导入
                                    </el-button
                                    >
                                </el-popover>
                </span>
                            </div>
                        </el-form>
                    </div>
                    <div class="tabbox">
                        <el-table
                                :data="dataList"
                                height="100%"
                                border
                                class="tabbox"
                                ref="multipleTable"
                                :header-cell-style="{background:'#f2f6fc',color:'#606266'}"
                                @selection-change="handleSelectionChange"
                        >
                            <el-table-column type="selection" width="55" align="center"></el-table-column>
                            <el-table-column prop="name" width="120" label="名称" align="center">
                                <template slot-scope="scope">
                                    <span>{{scope.row.name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="startDate" label="入住日期" width="160" align="center">
                                <template slot-scope="scope">
                                    <span>{{scope.row.startDate}}</span><br/>
                                    <span>{{scope.row.endDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="personal" label="入住人数" width="100" align="center">
                                <template slot-scope="scope">
                                    <span>{{scope.row.personal}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="type" width="100" label="房间数量" align="center">
                                <template slot-scope="scope">
                                    <span>{{scope.row.number}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="enabled" label="状态" width="100" align="center">
                                <template slot-scope="scope">
                                    <span>{{scope.row.disabled?'已禁用':'已启用'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
                                    <el-button type="text" class="red" @click="handleDelete(scope.$index, scope.row)">
                                        删除
                                    </el-button>
                                    <el-button type="text" v-if="scope.row.disabled" @click="disabled(scope.row)">
                                        禁用
                                    </el-button>
                                    <el-button type="text" v-else @click="enabled(scope.row)">
                                        启用
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="fb">
                        <el-pagination
                                class="pag"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 15, 20, 50, 100]"
                                :page-size="pagesize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                        ></el-pagination>
                    </div>
                </div>
                <DeleteDialog
                        :delVisible="delVisible"
                        @deleteData="deleteData"
                        @handleCloseVisible="handleCloseVisible"
                ></DeleteDialog>
                <EditRoomType :editShow="editShow" :editData="editData" @backFunStu="getFunStu"></EditRoomType>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import ProjectHotel from "../../../components/systemSetup/tree/ProjectHotel";
    import EditRoomType from "../../../components/systemSetup/EditRoomType";

    export default {
        data() {
            return {
                tableHeight: window.innerHeight - 200,
                searchForm: {
                    keyword: ""
                },
                action: localStorage.getItem("url") + "/Upload/File",
                projectId: localStorage.getItem("project_Id"),
                projectHotelId: 0,
                delVisible: false,
                editShow: false,
                listShow: true,
                dataList: [],
                editData: null,
                projectRoomTypeId: null
            };
        },
        created() {
            this.searchSubmit();
        },
        methods: {
            searchSubmit() {
                this.currentPage = 1;
                this.getData()
            },
            getPTypeId(id) {
                this.projectHotelId = id;
                this.getData();
            },
            // 获取数据
            getData() {
                var search = {
                    name: this.searchForm.keyword,
                    pageIndex: this.currentPage - 1,
                    pageSize: this.pagesize,
                    projectId: this.projectId,
                    hotelId: this.projectHotelId
                }
                this.$axios.post("/ProjectRoomType/Search", search).then(res => {
                    if (res.data.hasError == false) {
                        this.dataList = [...res.data.data]
                        this.total = res.data.total;
                    }
                });
            },
            handleSizeChange(val) {
                this.pagesize = val;
                this.getData();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getData();
            },
            handleEdit(index, row) {
                this.editData = row;
                this.listShow = false;
                this.editShow = true;
            },
            searchSubmit() {
                this.currentPage = 1;
                this.getData()
            },
            addSubmit() {
                this.projectRoomTypeId = "";
                this.editData = null;
                this.listShow = false;
                this.editShow = true;
            },
            handleDelete(index, row) {
                this.projectRoomTypeId = row.projectRoomTypeId;
                this.delVisible = true;
            },
            deleteData() {
                this.$axios.delete(`/ProjectRoomType/${this.projectRoomTypeId}`).then(res => {
                    if (res.data.hasError == false) {
                        this.$message.success("删除成功");
                        this.delVisible = false;
                        this.searchSubmit();
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            },
            uploadChange(file, fileList) {
                let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

                this.file = event.currentTarget.files[0];
                var rABS = false; //是否将文件读取为二进制字符串
                var f = this.file;

                var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
                FileReader.prototype.readAsBinaryString = function (f) {
                    var binary = "";
                    var rABS = false; //是否将文件读取为二进制字符串
                    var pt = this;
                    var wb; //读取完成的数据
                    var outdata;
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var bytes = new Uint8Array(reader.result);
                        var length = bytes.byteLength;
                        for (var i = 0; i < length; i++) {
                            binary += String.fromCharCode(bytes[i]);
                        }
                        var XLSX = require("xlsx");
                        if (rABS) {
                            wb = XLSX.read(btoa(fixdata(binary)), {
                                //手动转化
                                type: "base64",
                            });
                        } else {
                            wb = XLSX.read(binary, {
                                type: "binary",
                            });
                        } // outdata就是你想要的东西 excel导入的数据
                        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
                        let ar = [];
                        outdata.map((v) => {
                            let obj = {};
                            obj.name = v.房间类型;
                            obj.personal = v.入住人数;
                            obj.number = v.房间数量;
                            obj.startDate = v.开始日期;
                            obj.endDate = v.结束日期;
                            obj.disabled = false;
                            ar.push(obj);
                        });
                        localStorage.setItem("attr", JSON.stringify(ar));
                    };
                    reader.readAsArrayBuffer(f);
                };
                if (rABS) {
                    reader.readAsArrayBuffer(f);
                } else {
                    reader.readAsBinaryString(f);
                }
            },
            download() {
                var url = localStorage.getItem("url");
                if (url.lastIndexOf("/api") == url.indexOf("/api")) {
                    window.open(url.replace("/api", "/") + "/data/酒店房间类型.xlsx");
                } else {
                    window.open(
                        url.substring(0, url.lastIndexOf("/api")) + "/data/酒店房间类型.xlsx"
                    );
                }
            },
            importData() {
                if (this.projectHotelId > 0) {
                    this.attr = JSON.parse(localStorage.getItem("attr"));
                    if (this.attr && this.attr.length > 0) {
                        const loading = this.$loading({
                            lock: true,
                            text: "Loading",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)",
                        });
                        this.$axios
                            .put("/ProjectRoomType/batchAdd/" + this.projectHotelId, this.attr)
                            .then((res) => {
                                if (res.data.hasError == false) {
                                    loading.close();
                                    localStorage.setItem("attr", null);
                                    this.getData();
                                    this.$message.success(res.data.message);
                                } else {
                                    this.$message.error(res.data.message);
                                    loading.close();
                                }
                            })
                            .catch(function () {
                                loading.close();
                            });
                    } else {
                        this.$message.error("没有可上传的数据");
                    }
                } else {
                    this.$message.error("请选择酒店");
                }
            },
            handleCloseVisible() {
                this.projectRoomTypeId = "";
                this.delVisible = false;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getFunStu() {
                this.listShow = true;
                this.editShow = false;
                this.searchSubmit();
            },
            disabled(data) {
                this.$confirm("是否确认禁用？", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                    // type: 'warning'
                }).then(() => {
                    this.$axios.put(`/ProjectRoomType/Disabled/${data.projectRoomTypeId}`)
                        .then(res => {
                            if (res.data.hasError) {
                                this.$message.error(res.data.message);
                            } else {
                                this.$message({type: "success", message: "禁用成功!"});
                                //刷新
                                this.getData();
                            }
                        });
                })
                    .catch(() => {
                        this.$message({type: "info", message: "已取消禁用"});
                    });
            },
            enabled(data) {
                this.$confirm("是否确认启用？", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                    // type: 'warning'
                }).then(() => {
                    this.$axios.put(`/ProjectRoomType/Enabled/${data.projectRoomTypeId}`)
                        .then(res => {
                            if (res.data.hasError) {
                                this.$message.error(res.data.message);
                            } else {
                                this.$message({type: "success", message: "启用成功!"});
                                //刷新
                                this.getData();
                            }
                        });
                })
                    .catch(() => {
                        this.$message({type: "info", message: "已取消启用"});
                    });
            },
        },
        components: {
            ProjectHotel,
            EditRoomType
        }
    };
</script>
<style lang="scss" scope>
    .handle-box3 {
        height: 50px;
    }

    .file-up {
        width: 100px;
        position: absolute;
        height: 32px;
        opacity: 0;
    }

    .table-wrap {
        margin-left: 10px;
        height: 100%;
    }

    .el-main {
        border-radius: 5px;
        position: relative;
    }

    .uers-left {
        float: left;
    }

    .uers-right {
        float: right;
    }

    .power_tab {
        height: calc(100% - 100px);
        box-sizing: border-box;
        overflow: auto;

        .has-gutter {
            /deep/ .el-checkbox {
                display: none;
            }
        }
    }
</style>